/*******
Common Function Used In Diamond Listing & Detail Page 
********/

/*** Pre Define Constant Values For Webservice Call ***/
const api = "https://py.ecolabdiamonds.com.au/live/graphql/";
const rapnetDiamondListingApi = "rapnetDiamondData";
const labDiamondListingApi = "diamondData";
const rapnetDiamondDetailApi = "rapnetDiamondById";
const labDiamondDetailApi = "diamondById";
const diamondSearchByReportApi = "diamondByStockorcert";
const rapnetDiamondAddToCart = "rapnetDiamondAddToCart";
const labDiamondAddToCart = "diamondAddToCart";
const productMetafield = "productMetafield";
const rapnetRingAddToCart = "rapnetRingAddToCart";
const labRingAddToCart = "diamondFinalRing";
const shopUrl = "https://"+window.Shopify.shop;
const collectionHandel = "ring";
const diamondCollectionHandel = "diamonds";
const diamondResultPageLimit = 20;
const settingProductsCountry = "HK";
const diamondTierListingApi = "diamondTier";
/*** End ***/

/*** Store Language Code ***/
const store_lang = window.Shopify.locale;
/*** End ***/

/*** Get Query Parameter Array from URL ***/
function getQueryMap(query) {
    if(typeof query !== 'string') {
       return null;
    }
    
    var toType = function(a) {
      return ({}).toString.call(a).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }, map = {};
    
  // map the hit query into a proper object
  query.replace(/([^&|\?=]+)=?([^&]*)(?:&+|$)/g, function (match, key, value) {
      if (key in map) {
          // the key already exists, so we need to check if it is an array, if not, make it an array and add the new value
          if (toType(map[key]) !== 'array') {
              // it's not an array - make it an array
              map[key] = [map[key]];
          }
          // push the new value into the array
          map[key].push(value);
      } else {
          // put the value into the map
          map[key] = value;
      }
  });
  return map;
}
/*** End ***/

/*** AddCommas in price start ***/
function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}
/*** addCommas in price end ***/

/*** Get Certificate File URL Start ***/
function getCertificateUrl(diamondData) {
  var certificateFile = '';
  var diaLab = diamondData.lab;
  var diaCertNo = diamondData.certificateNumber;
  var diaCarat = diamondData.caratWeight;
  
  if(diamondData.certificateFile != ''){
    certificateFile = diamondData.certificateFile;
  }else{
    switch(diaLab)
      {
        case "GIA":
            certificateFile = 'https://www.gia.edu/cs/Satellite?reportno='+diaCertNo+'&childpagename=GIA%2FPage%2FReportCheck&pagename=GIA%2FDispatcher&c=Page&cid=1355954554547#main-content';
            break;
        case "IGI":
            certificateFile = 'https://www.igi.org/verify-your-report/?r='+diaCertNo;
            break;
        case "HRD":
            certificateFile = 'https://my.hrdantwerp.com/?record_number='+diaCertNo+'&weight='+diaCarat;
            break;
        case "AGS":
            certificateFile = 'https://www.agslab.com/reportTypes/pdqr.php?StoneID='+diaCertNo+'&Weight='+diaCarat+'&D=1';
            break;
        case "GCAL":
          certificateFile = 'https://www.gcalusa.com/certificate-search.html?certificate_id='+diaCertNo;
          break;
        default:
            certificateFile = "";
      }
  }    
  return certificateFile;
}
/*** End ***/

/*** Diamond Broken Image Fixes start ***/ 
function imgError(image,defaultImage) {
  image.onerror = "";
  image.src = defaultImage;
  return true;
}
/*** End ***/  

/*** Get Diamond Price Start ***/
function getDiamondPrice(currencyRate,finalPrice) {  
  var final_dia_price = finalPrice * currencyRate; 
  var dia_formatted_price = Math.ceil(final_dia_price);      
  dia_formatted_price = Shopify.formatMoney(dia_formatted_price * 100, theme.moneyFormat);
  return dia_formatted_price;
}
/*** End ***/

/*** Get Diamond Type Start ***/
function getDiamondType(diamondType) {
  var type = diamondType;
  if(type == 'white'){
    dia_type = 'Natural';
  }else{
    dia_type = 'Lab Grown';
  }
  return dia_type;
}
/*** End ***/

/*** Get Diamond Image Start ***/
function getDiamondImage(diamondData) {
  var diamondStockImage = [];
  //get diamond stock image url
  $.each(diamondImageUrl, function(i, diamondImage) {   
    if(diamondData.fancyColor == ''){
      var imageParam = diamondData.shape.toLowerCase()+'_generic';
    }else{
      var imageParam = diamondData.shape.toLowerCase()+'_'+diamondData.fancyColor.toLowerCase()+'_generic';
    }     
    
    if(diamondImage.includes(imageParam)){    
      diamondStockImage.push(diamondImage);
    }
  });

  var diamond_image = diamondData.diamondImage;
  if(diamondData.diamondImage != '' && diamondData.diamondImage != 'NA' && diamondData.diamondImage != 'N/A' && diamondData.diamondImage != 'None'){
    diamond_image = diamondData.diamondImage;
  }else{      
    diamond_image = diamondStockImage[0];     
  }
  return diamond_image;
}
/*** End ***/

/*** Get Diamond Name Start ***/
function getDiamondName(diamondData,diamondType) {
  var diamond_name = diamondData.caratWeight + "-Carat " + diamondData.shape + " Shape "+ diamondType +" Diamond ";
  return diamond_name;
}
/*** End ***/

/*** Get Diamond measurement Start ***/
function getDiamondMeasurement(diamondData) {
  if(diamondData.measurement != ''){
    var measurements = diamondData.measurement;
  }else{
    var measurements = diamondData.length + " * " + diamondData.width + " * " + diamondData.depth;
  }  
  return measurements;
}
/*** End ***/

/*** Get Diamond Girdle Start ***/
function getDiamondGirdle(diamondData) {
  if(diamondData.girdleMin != '' && diamondData.girdleMax != '' && diamondData.girdleMin != 0 && diamondData.girdleMax != 0){
    var girdle = diamondData.girdleMin+"-"+diamondData.girdleMax;
  }else if(diamondData.girdleMax == '' && diamondData.girdleMax == 0){
    var girdle = diamondData.girdleMin;
  }else if(diamondData.girdleMin == '' && diamondData.girdleMax == 0){
    var girdle = diamondData.girdleMax;
  }else{
    var girdle = 'NA';
  }  
  return girdle;
}
/*** End ***/

/*** Get Diamond Detail Information ***/
function getDiamondDetailInfo(diamondData) {  
  var diamondInformation = getDiamondInformationLayout(diamondData);
  
  var detailInfo = '';  
  detailInfo += '<div class="tps-product-details">';
  detailInfo += '<div class="tps-product-detail-section-heading" data-section="diamond-info"><h2>'+translations.titleDiamondDetails+'</h2><span class="tps-tab-arrow tps-arrow-down"></span></div>';
  detailInfo += '<div class="tps-product-details-info tps-product-details-diamond-info" style="display:none;">';   
  detailInfo += diamondInformation;
  detailInfo += '</div>';
  detailInfo += '</div>';
  return detailInfo;
}
/*** End ***/

/*** Get Diamond Detail Information Layout ***/
function getDiamondInformationLayout(diamondData) {
  var diamond_certificate_url = getCertificateUrl(diamondData);
  var diamond_measurements = getDiamondMeasurement(diamondData);

  //Dynamic Diamond Information Array 
  var diamondInformation = {
    "diamondCertificateNumber" : translations.titleCertificateNumber+' - '+diamondData.certificateNumber,
    "diamondStockId" : translations.titleStockID+' - '+diamondData.stockNumber,
    "diamondShape"   : translations.titleShape+' - '+diamondData.shape,
    "diamondCarat"   : translations.titleCaratWeight+' - '+diamondData.caratWeight,
    "diamondCut"     : translations.titleCut+' - '+diamondData.cut,
    "diamondColor"   : translations.titleColor+' - '+diamondData.color,
    "diamondFancyColor" : translations.titleColor+' - '+diamondData.fancyColor,
    "diamondClarity" : translations.titleClarity+' - '+diamondData.clarity,
    "diamondReport"  : translations.titleGradingReport+' - '+diamondData.lab+' - '+diamond_certificate_url,
    "diamondFluorescence" : translations.titleFluorescence+' - '+diamondData.flourIntensity,
    "diamondTable"   : translations.titleTable+' - '+diamondData.tablePerc,
    "diamondDepth"   : translations.titleDepth+' - '+diamondData.deptPerc,
    "diamondMeasurement" : translations.titleMeasurement+' - '+diamond_measurements,
    "diamondRatio"   : translations.titleRatio+' - '+diamondData.ratio,
    "diamondSymmetry": translations.titleSymmetry+' - '+diamondData.symmetry,
    "diamondPolish"  : translations.titlePolish+' - '+diamondData.polish,
    "diamondgirdle"  : translations.titleGirdle+' - '+diamondData.girdle,
    "diamondCulet"   : translations.titleCulet+' - '+diamondData.culet,
    "diamondIntensity"  : translations.titleIntensity+' - '+diamondData.fancyColorIntensity,
    "diamondOvartone"   : translations.titleOvertone+' - '+diamondData.fancyColorOvertone,
  };
  //end

  //Diamond Information HTML Layout
  var detailInfo = '';
  if(diamondInformation != ''){
     var j = 1;
     $.each(diamondInformation, function(i, diamondInfo) {
       var diamondInfoArray = diamondInfo.split(" - ");
       if(diamondInfoArray.length > 1){
         var infoLable = diamondInfoArray[0];
         var infoValue = diamondInfoArray[1];
        
         if(diamondInfoArray[1] != ''){
           if(diamondInfoArray.length == 3){
             var infoUrl = diamondInfoArray[2];
             detailInfo += '<div class="detail-column-row-'+j+' tps-single-info"><span class="detail-row-1 tps-txt-title">'+infoLable+'</span><span class="detail-row-2 tps-txt-info"><a href="'+infoUrl+'" target="_blank" alt="Certificate URL" title="Certificate Title">'+infoValue+'</a></span></div> ';
           }else{
             if(infoValue != 'null'){
               detailInfo += '<div class="detail-column-row-'+j+' tps-single-info"><span class="detail-row-1 tps-txt-title">'+infoLable+'</span><span class="detail-row-2 tps-txt-info">'+infoValue+'</span></div> ';
             }             
           } 
           j++;
         }
       }        
    });
  }
  //end
  
  return detailInfo;
}
/*** End ***/

/*** Config function forpre define module url start ***/
if(store_lang == 'de'){
  var tps_config = {
	"urls": {        
        "lab_diamond": "/pages/labor-weisser-diamant",
        "loose_color_diamond": "/pages/naturlicher-farbiger-diamant",
        "loose_diamond": "/pages/naturlicher-weisser-diamant",
        "loose_diamond_detail": "/pages/diamant-einzelheiten",
	}
  }
}else{
  var tps_config = {
	"urls": {        
        "loose_diamond": "/pages/ringbuilder-lab-grown-white-diamonds",
        "lab_diamond": "/pages/ringbuilder-lab-grown-white-diamonds",
        "loose_color_diamond": "/pages/ringbuilder-natural-color-diamonds", 
        "lab_color_diamond": "/pages/ringbuilder-lab-grown-coloured-diamonds",
        "loose_diamond_detail": "/pages/ringbuilder-diamond-details",
        "setting_listing": "/collections/ring",
        "final_ring": "/pages/final-engagement-ring",
	}

  }
}
/*** End ***/

/*** Remove HTML Elements In Mobile ***/
function removeHtmlElementsInMobile() {  
  jQuery('.tps-mobile-hide').remove();	
}
/*** End ***/

/*** Remove HTML Elements In Desktop ***/
function removeHtmlElementsInDesktop() {
  jQuery('.tps-desktop-hide').remove();	
}
/*** End ***/

/*** Get Closest Number From Array ***/
function getClosestNum(num, ar) {
	var i = 0,
		closest, closestDiff, currentDiff;
	if (ar.length) {
		closest = ar[0];
		for (i; i < ar.length; i++) {
			closestDiff = Math.abs(num - closest);
			currentDiff = Math.abs(num - ar[i]);
			if (currentDiff < closestDiff) {
				closest = ar[i];
			}
			closestDiff = null;
			currentDiff = null;
		}
      
		//returns first element that is closest to number
		return closest;
	}
	//no length
	return false;
}
/*** End ***/

/*** Get Array Index Value ***/  
function get_index(value, array) {
	var pos = 0
	for (i = 0; i < array.length; i++) {
		if (array[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}
/*** End ***/

/*** Set Selected Filters For Session Filters After Reloading Page start ***/
function setSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') {   
	if (input_value == 'price') {
		$('.tps-selected-filter-container').find('li[data-input="price"]').remove();
	}else if (input_value == 'carat') {     
		$('.tps-selected-filter-container').find('li[data-input="carat"]').remove();
	}else if (input_value == 'depth') {
		$('.tps-selected-filter-container').find('li[data-input="depth"]').remove();
	}else if (input_value == 'table') {
		$('.tps-selected-filter-container').find('li[data-input="table"]').remove();
    }else if (input_value == 'cut') {
		$('.tps-selected-filter-container').find('li[data-input="cut"]').remove();
	}else if (input_value == 'polish') {
		$('.tps-selected-filter-container').find('li[data-input="polish"]').remove();
	}else if (input_value == 'symmetry') {
		$('.tps-selected-filter-container').find('li[data-input="symmetry"]').remove();
	}else if (input_value == 'fluorescence') {
		$('.tps-selected-filter-container').find('li[data-input="fluorescence"]').remove();
	}else if (input_value == 'clarity') {
		$('.tps-selected-filter-container').find('li[data-input="clarity"]').remove();
	}else if (input_value == 'color') {
		$('.tps-selected-filter-container').find('li[data-input="color"]').remove();
	}else if (input_value == 'intensity') {
		$('.tps-selected-filter-container').find('li[data-input="intensity"]').remove();
    }else if (input_value == 'ratio') {
		$('.tps-selected-filter-container').find('li[data-input="ratio"]').remove();
	}else if (input_value == 'search-certificate') {
		$('.tps-selected-filter-container').find('li[data-input="search-certificate"]').remove();
	}
  
	var value = filter_value.split(':');
    var filterId = value[0].replace(/[\W_]/g, "_");
	if (hasSelectedClass) {
		var html = '';
        var filter_lable = value[1].trim();
        if(input_value != 'price' && input_value != 'carat' && input_value != 'depth' && input_value != 'table' && input_value != 'cut' && input_value != 'polish' && input_value != 'symmetry' && input_value != 'fluorescence' && input_value != 'clarity' && input_value != 'color' && input_value != 'intensity') {
          //filter_lable = filter_lable.replace(/\-/g, ' ');
        }
		html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter_value="' + filter_value + '"><div class="tps-filter-values">' + filter_lable + '<span class="tps-filter-remove-option"></span></div></li>';
		if ($('#' + filterId + '-container').length > 0) {
			$('#' + filterId + '-container').append(html);
		} else {
			var elecontainer = '<ul id="' + filterId + '-container"><span class="tps-applied-filter-lable">' + value[0] + ':</span></ul>';
			$('.tps-selected-filter-container').append(elecontainer);
			$('#' + filterId + '-container').append(html);
		}    
	} else {
		$('.tps-selected-filter-container').find('li[data-filter_value="' + filter_value + '"]').remove();
		if ($('input[value="' + input_value + '"]').length > 0) {
			$('input[value="' + input_value + '"]').prop('checked', false);
		}

		if ($('#' + filterId + '-container li').length == 0) {
			$('#' + filterId + '-container').remove();
		}
	}
	if ($('.tps-selected-filter-container li').length > 0) {
		$('.tps-selected-filter-wrapper').show();
	} else {
		$('.tps-selected-filter-wrapper').hide();
	}
}
/*** set selected filters for session filters after reloading page end ***/

/*** Sort By Dropdown Open Close ***/
function sortByOpen() {
  if(jQuery('.tps-sort-dropdown-menu').css('display') !== 'none'){		
      sortByClose();
  }else {		
      jQuery('.tps-sort-dropdown-menu').css('display', 'block');

      if(jQuery(window).width() <= 824){
        jQuery('.tps-sort-dropdown-menu').addClass('tps-sort-dropdown-menu-show');
      }
  }
}
/*** End ***/

/*** Sort By Dropdown Close OnMouseLeave ***/
function sortByClose() {
  jQuery(".tps-sort-dropdown-menu").css('display', 'none');

  if(jQuery(window).width() <= 824){
    jQuery('.tps-sort-dropdown-menu').removeClass('tps-sort-dropdown-menu-show');
  }
}
/*** End ***/

/**** Mobile Filter Open/Close Start ****/ 
function mobileFilters(action){  
  if(action == 'open'){
    $(".tps-filter-container").addClass('tps-mobile-filters');
    $('body').addClass('tps-mobile-filters-open');
  }else{
    $(".tps-filter-container").removeClass('tps-mobile-filters');
    $('body').removeClass('tps-mobile-filters-open');
  }  
}
/*** End ***/

/**** Mobile Filter Button Sticky Start ****/ 
$(window).scroll(function(){
    if ($(this).scrollTop() > 500) {
       $('.tps-mobile-filter-button-section').addClass('tps-sticky-btn');
    } else {
       $('.tps-mobile-filter-button-section').removeClass('tps-sticky-btn');
    }
});
/*** End ***/

/*** Create & Update Session Filters Array Start ***/
function updateSessionFilters(arrayKey, filterKey, newValues) {
    // Retrieve the filters object from local storage or initialize an empty object
    let filters = JSON.parse(localStorage.getItem(arrayKey)) || {};

    // Split the newValues string by commas to handle multiple values
    let newValuesArray = newValues.split(',').map(value => value.trim());
 
    // Replace the old values with new ones
    filters[filterKey] = newValuesArray;
 
    // Save the updated filters object back to local storage
    localStorage.setItem(arrayKey, JSON.stringify(filters));
}
/*** Create & Update Session Filters Array End ***/


/*** Refine Your Results Focus To Filter Section ***/
function refineYourResults(){
  var target = '.tps-filter-container'; 
  $('html, body').animate({
        scrollTop: $(target).offset().top - 250
  }, 'slow'); 
}
/*** End ***/

/*** Get Daimond ID From Url Start ***/
function getURLParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}    
/*** End ***/

/*** Product Detail Info Open Close ***/
$(document).on("click", ".tps-product-detail-section-heading", function() {
  var data_section = jQuery(this).attr("data-section");
  if(jQuery(this).hasClass('active')){
    jQuery(".tps-product-detail-section-heading").removeClass('active');
    jQuery('.tps-tab-arrow').addClass('tps-arrow-down').removeClass('tps-arrow-up');
    jQuery('.tps-tab-arrow').addClass('tps-arrow-down').removeClass('tps-arrow-up');
    jQuery('.tps-product-details-info').slideUp('slow');
  }else{
    jQuery('.tps-product-details-info').hide();
    jQuery(".tps-product-detail-section-heading").removeClass('active');
    jQuery(this).addClass('active');
    jQuery('.tps-tab-arrow').removeClass('tps-arrow-up').addClass('tps-arrow-down');
    jQuery(this).find('span').addClass('tps-arrow-up').removeClass('tps-arrow-down');    
    jQuery('.tps-product-details-'+data_section).slideDown('slow');
  }    
});
/*** End ***/

/*** Vertical Thumbnail Gallery Slick Slider Start ***/
function settingGalleryThumbnailSlider(verticalSlider){
  if(jQuery(window).width() <= 900){
    $('.tps-mobile-hide').remove();
    $('.tps_image_desk_banner').remove();
    var verticalSlider = false;
  }else{
    $('.tps-desktop-hide').remove();
    $('.tps_image_mob_banner').remove();
  }
  $('.tps-main-image-slide').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       infinite: false,
       arrows: false,       
       adaptiveHeight: true,
       asNavFor: '.tps-thumb-image-slide',
       draggable: false,
       lazyLoad: 'progressive',
       responsive 		: [
		  		{
			      	breakpoint: 992,
			      	settings: {
			        	slidesToShow 	: 1,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
		  		{
			      	breakpoint: 768,
			      	settings: {
			        	slidesToShow 	: 1,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
			    {
			      	breakpoint: 640,
			      	settings: {
			        	slidesToShow 	: 1,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
			    {
			      	breakpoint: 581,
			      	settings: {
			        	slidesToShow 	: 1,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
		 	], 
   });

  if(verticalSlider == true){
    $('.tps-thumb-image-slide').slick({
         vertical: true,
         verticalSwiping: true,
         slidesToShow: 4,
         slidesToScroll: 1,
         infinite: false,
         asNavFor: '.tps-main-image-slide',        
         focusOnSelect: true,
         draggable: false, 
         arrows: true,
         lazyLoad: 'progressive',
     });
  }else{
    $('.tps-thumb-image-slide').slick({
       vertical: verticalSlider,
       verticalSwiping: true,
       slidesToShow: 5,
       slidesToScroll: 1,
       infinite: false,
       asNavFor: '.tps-main-image-slide',        
       focusOnSelect: true,
       draggable: false, 
       arrows: true,
       lazyLoad: 'progressive',
       responsive 		: [
		  		{
			      	breakpoint: 992,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
		  		{
			      	breakpoint: 768,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
			    {
			      	breakpoint: 640,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
			    {
			      	breakpoint: 581,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
                        arrows          : false,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
		 	], 
    });
  }
}
/*** Vertical Thumbnail Gallery Slick Slider End ***/

/*** Get Formatted Metal Value For Image Alt Text Start ***/  
function getFromatedMetalValue(setting_metal){
  if(setting_metal.indexOf("18K ") >= 0){ 
     metal = setting_metal.replace('18K ','').trim();                 
  }else if(setting_metal.indexOf("14K ") >= 0){ 
     metal = setting_metal.replace('14K ','').trim();         
  }else{ 
     metal = setting_metal;
  }  
  return metal;
}
/*** Get Formatted Metal Value For Image Alt Text End ***/ 

/*** Get Final Ring Product Price Start ***/
function getFinalProductPrice(){
  var setting_info = JSON.parse(localStorage.getItem("ring-selected-setting"));  
  var diamond_info = JSON.parse(localStorage.getItem("ring-selected-diamond"));

  var setting_price = setting_info[0].setting_price/100;
  var diamond_price = diamond_info[0].diamond_price;

  var final_price = parseInt(setting_price)+parseInt(diamond_price);
  final_price = getPriceWithCurrencySymbol(final_price);
  return final_price;
}

function getPriceWithCurrencySymbol(price){
  price = Shopify.formatMoney(price*100,theme.moneyFormat);
  return price;
}
/*** Get Final Ring Product Price End ***/

/*** Show Product Detail & Final Ring Page Loader Start ***/
function showProductLoader(galleryStyle){
  if(galleryStyle == 'grid-view'){            
    if(jQuery(window).width() <= 899){
      jQuery(".tps-loader-horizontal-thumb-slider").show();
    }else{
      jQuery(".tps-loader-"+galleryStyle).show();
    }
  }else{
    jQuery(".tps-loader-"+galleryStyle).show();
  }
}
/*** Show Product Detail & Final Ring Page Loader End ***/

/*** get product shape from tags ***/
function getProductShape(productTags){
  var shapeValue = "";
  $(productTags).each(function(index, tag){
    if(tag.indexOf('Shape') > -1){
      var shapeTag = tag.split('_');
      shapeValue = shapeTag[1];
      return;
    }else if(tag.indexOf('shape') > -1){
      var shapeTag = tag.split('_');
      shapeValue = shapeTag[1];
      return;
    }
  });
  return shapeValue;
}
/*** get product shape from tags ***/

/*** get product style from tags ***/
function getProductStyle(productTags){
  var styleValue = "";
  $(productTags).each(function(index, tag){
    if(tag.indexOf('Style') > -1){
      var styleTag = tag.split('_');
      styleValue = styleTag[1];
      return;
    } else if(tag.indexOf('style') > -1){
      var styleTag = tag.split('_');
      styleValue = styleTag[1];
      return;
    }
  });
  return styleValue;
}
/*** get product style from tags ***/

/*** Get Diamond Gallery 360 Video HTML ***/
function getGallery360VideoLayout(diamondVideo) {
   var video_url = diamondVideo;
  //console.log("video_url",video_url);
   if(video_url != ''){
    var videoHtml = '';
    if (video_url.indexOf("mp4") > -1 || video_url.indexOf(".mov") > -1) {
      videoHtml ='<video class="tps-dia-gallery-video" controls autoplay playsinline>';
      videoHtml +='<source src="'+video_url+'" type="video/mp4">';
      videoHtml +='</video>';     
    }else{      
       videoHtml ='<iframe class="tps-gallery-video-iframe" id="tps_diamond_video_iframe" src="'+video_url+'" scrolling="no"></iframe>';

       //set iframe width as per device
       if (video_url.indexOf("https://loupe360.com/diamond/") > -1){              
          video_url = video_url.replace('/500/500', '/resp/true/autoplay');
          videoHtml ='<iframe class="tps-dia-gallery-video-iframe" id="tps_diamond_video_iframe" src="'+video_url+'" width="500px" height="500px" scrolling="no"></iframe>';
       }        
      
    }
    return videoHtml;
  }  
}
/*** End ***/

/*** Get Diamond 3D Model HTML ***/
function getGalleryThreeDLayout(diamondData) {
  var shape = diamondData.shape;
  var width = diamondData.width;
  var length = diamondData.length;
  var depth = diamondData.deptPerc;  
  var table = diamondData.tablePerc;
  var girdle = diamondData.girdle;
  if(girdle == ''){
    if(diamondData.girdleMin != '' && diamondData.girdleMax != '' && diamondData.girdleMin != 0 && diamondData.girdleMax != 0){
      girdle = diamondData.girdleMin+"-"+diamondData.girdleMax;
    }
  }

  var threed_url = '';
  threed_url += 'https://php71.transpacific-software.com/3d_diamond/index.php?getShape='+shape.toLowerCase();
  threed_url += '&getWidth='+width;
  threed_url += '&getLength='+length;
  threed_url += '&getDepth='+depth;
  threed_url += '&getTable='+table;
  threed_url += '&getGirdle='+girdle;

  if(threed_url != ''){    
    theedHtml ='<iframe class="tps-dia-gallery-threed-model" src="'+threed_url+'" height="400px" width="400px" scrolling="no"></iframe>';	
    return theedHtml;
  }
}
/*** End ***/

/*** Mobile Step Icon Click Info Popup Start ***/
$(document).on("click", ".tps-step-icon", function(){
  //if(jQuery(window).width() < 1024){
    var data_step = jQuery(this).attr("data-step");
      
    jQuery(".tps-step-product-info").removeClass('tps-step-product-info-show');
    jQuery(".tps-"+data_step+"-step-product-info").addClass('tps-step-product-info-show');
 //} 
});
/*** Mobile Step Icon Click Info Popup End ***/

/*** if outside click close steps popup start ***/
$(document).on("click", function(e){
  var currentTargetEle = jQuery(e.target);
  if(currentTargetEle.parents('.tps-step-block-content').length > 0)
    return;
  jQuery(".tps-step-product-info").removeClass('tps-step-product-info-show');
});
/*** if outside click close steps popup end ***/
/*******
End
********/